<nav class="navbar navbar-expand-lg fixed-top bg-primary navbar-dark navbar-custom">
  <div class="container-fluid">
    <a routerLink="/" class="navbar-brand">
      <img src="../../../../assets/img/Runtech-logo.png" alt="Logo" width="90" />
    </a>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarContent"
      aria-controls="navbarContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0 gap-3">
        <!-- Download User Manual button (left of user icon) -->
        <li class="nav-item d-flex align-items-center me-1">
          <a
            class="btn btn-outline-light btn-sm download-btn"
            href="assets/templates/runtech_user_manual.pdf"
            download="runtech_user_manual.pdf"
            aria-label="Download User Manual">
            <!-- download icon from assets -->
            <img src="assets/img/download.svg" alt="" aria-hidden="true" width="16" height="16" class="me-1" />
            User Manual
          </a>
        </li>
        <!-- language selector removed -->
        <li class="nav-item d-lg-none">
          <a class="nav-link" (click)="toggleProfile()">
            <img class="profile-image" src="assets/img/default_profile.svg" alt="Profile" />
          </a>
          <ul class="dropdown-menu dropdown-menu-end w-75" [class.show]="isProfileMenuOpen">
            <li>
              <div class="dropdown-item">
                <img class="profile-image-icon me-2" src="assets/img/default_profile.svg" alt="Profile Icon" />
                <div class="profile-details">
                  <span>{{ username }}</span>
                  <span>{{ email }}</span>
                </div>
              </div>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button class="dropdown-item" (click)="logout()">Logout</button>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown d-none d-lg-block">
          <a
            class="nav-link dropdown-toggle m-0 p-0 d-flex align-items-center"
            href="#"
            id="profileDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            <img class="profile-image" src="assets/img/default_profile.svg" alt="Profile" />
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
            <li>
              <div class="dropdown-item d-flex align-items-center">
                <img class="profile-image-icon me-2" src="assets/img/default_profile.svg" alt="Profile Icon" />
                <div class="profile-details">
                  <span>{{ username }}</span>
                  <span>{{ email }}</span>
                </div>
              </div>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button class="dropdown-item" (click)="logout()">Logout</button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
